import { Button } from '@fourthwall/components';
import React from 'react';
import { Feature } from '../Feature/Feature';
import { PlanOption } from '../PlanOption/PlanOption';
import { TermsFooter } from '../TermsFooter/TermsFooter';
import * as S from './SelectPlanStage.styled';
export const SelectPlanStage = ({ plans, selectedPlanId, onPlanSelect, onContinue, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Content, null,
            React.createElement(S.FeaturesContainer, null,
                React.createElement(Feature, null, "Cancel any time"),
                React.createElement(Feature, null, "We\u2019ll remind you before each billing")),
            React.createElement(S.PlanOptionsContainer, null, plans.map((plan) => (React.createElement(PlanOption, { key: plan.id, plan: plan, selected: plan.id === selectedPlanId, onClick: () => onPlanSelect(plan.id) }))))),
        React.createElement(Button, { label: "Continue", appearance: "primary", fullWidth: true, onClick: onContinue }),
        React.createElement(TermsFooter, null)));
};
